import {
  convertAcreToHectare,
  convertAcreToSquareFoot,
  convertAcreToSquareInch,
  convertAcreToSquareMeter,
  convertAcreToSquareMile,
  convertAcreToSquareYard
} from "./AcreConversion";
import {
  convertHectareToAcre,
  convertHectareToSquareFoot,
  convertHectareToSquareInch,
  convertHectareToSquareMeter,
  convertHectareToSquareMile,
  convertHectareToSquareYard
} from "./HectareConversion";
import {
  convertSquareFootToAcre,
  convertSquareFootToHectare,
  convertSquareFootToSquareInch,
  convertSquareFootToSquareMeter,
  convertSquareFootToSquareMile,
  convertSquareFootToSquareYard
} from "./SquareFootConversion";
import {
  convertSquareInchToAcre,
  convertSquareInchToHectare,
  convertSquareInchToSquareFoot,
  convertSquareInchToSquareMeter,
  convertSquareInchToSquareMile,
  convertSquareInchToSquareYard
} from "./SquareInchConversion";
import {
  convertSquareMeterToAcre,
  convertSquareMeterToSquareYard,
  convertSquareMeterToSquareMile,
  convertSquareMeterToSquareInch,
  convertSquareMeterToSquareFoot,
  convertSquareMeterToHectare
} from "./SquareMeterConversion";
import {
  convertSquareMileToAcre,
  convertSquareMileToSquareYard,
  convertSquareMileToSquareMeter,
  convertSquareMileToSquareInch,
  convertSquareMileToSquareFoot,
  convertSquareMileToHectare
} from "./SquareMileConversion";
import {
  convertSquareYardToSquareMile,
  convertSquareYardToAcre,
  convertSquareYardToHectare,
  convertSquareYardToSquareFoot,
  convertSquareYardToSquareInch,
  convertSquareYardToSquareMeter
} from "./SquareYardConversion";

function getFinalAcreConversion(val, conType) {
  let result = "";
  if (conType === "actohe") {
    result = convertAcreToHectare(parseFloat(val));
  } else if (conType === "actoft") {
    result = convertAcreToSquareFoot(parseFloat(val));
  } else if (conType === "actoin") {
    result = convertAcreToSquareInch(parseFloat(val));
  } else if (conType === "actom") {
    result = convertAcreToSquareMeter(parseFloat(val));
  } else if (conType === "actomi") {
    result = convertAcreToSquareMile(parseFloat(val));
  } else if (conType === "actoyd") {
    result = convertAcreToSquareYard(parseFloat(val));
  }
  return result;
}

function getFinalHectareConversion(val, conType) {
  let result = "";
  if (conType === "hetoac") {
    result = convertHectareToAcre(parseFloat(val));
  } else if (conType === "hetoft") {
    result = convertHectareToSquareFoot(parseFloat(val));
  } else if (conType === "hetoin") {
    result = convertHectareToSquareInch(parseFloat(val));
  } else if (conType === "hetom") {
    result = convertHectareToSquareMeter(parseFloat(val));
  } else if (conType === "hetomi") {
    result = convertHectareToSquareMile(parseFloat(val));
  } else if (conType === "hetoyd") {
    result = convertHectareToSquareYard(parseFloat(val));
  }

  return result;
}

function getFinalSquareFootConversion(val, conType) {
  let result = "";
  if (conType === "fttoac") {
    result = convertSquareFootToAcre(parseFloat(val));
  } else if (conType === "fttohe") {
    result = convertSquareFootToHectare(parseFloat(val));
  } else if (conType === "fttoin") {
    result = convertSquareFootToSquareInch(parseFloat(val));
  } else if (conType === "fttom") {
    result = convertSquareFootToSquareMeter(parseFloat(val));
  } else if (conType === "fttomi") {
    result = convertSquareFootToSquareMile(parseFloat(val));
  } else if (conType === "fttoyd") {
    result = convertSquareFootToSquareYard(parseFloat(val));
  }

  return result;
}

function getFinalSquareInchConversion(val, conType) {
  let result = "";
  if (conType === "intoac") {
    result = convertSquareInchToAcre(parseFloat(val));
  } else if (conType === "intohe") {
    result = convertSquareInchToHectare(parseFloat(val));
  } else if (conType === "intoft") {
    result = convertSquareInchToSquareFoot(parseFloat(val));
  } else if (conType === "intom") {
    result = convertSquareInchToSquareMeter(parseFloat(val));
  } else if (conType === "intomi") {
    result = convertSquareInchToSquareMile(parseFloat(val));
  } else if (conType === "intoyd") {
    result = convertSquareInchToSquareYard(parseFloat(val));
  }
  return result;
}

function getFinalSquareMeterConversion(val, conType) {
  let result = "";
  if (conType === "mtoac") {
    result = convertSquareMeterToAcre(parseFloat(val));
  } else if (conType === "mtoyd") {
    result = convertSquareMeterToSquareYard(parseFloat(val));
  } else if (conType === "mtomi") {
    result = convertSquareMeterToSquareMile(parseFloat(val));
  } else if (conType === "mtoin") {
    result = convertSquareMeterToSquareInch(parseFloat(val));
  } else if (conType === "mtoft") {
    result = convertSquareMeterToSquareFoot(parseFloat(val));
  } else if (conType === "mtohe") {
    result = convertSquareMeterToHectare(parseFloat(val));
  }

  return result;
}

function getFinalSquareMileConversion(val, conType) {
  let result = "";
  if (conType === "mitoac") {
    result = convertSquareMileToAcre(parseFloat(val));
  } else if (conType === "mitoyd") {
    result = convertSquareMileToSquareYard(parseFloat(val));
  } else if (conType === "mitom") {
    result = convertSquareMileToSquareMeter(parseFloat(val));
  } else if (conType === "mitoin") {
    result = convertSquareMileToSquareInch(parseFloat(val));
  } else if (conType === "mitoft") {
    result = convertSquareMileToSquareFoot(parseFloat(val));
  } else if (conType === "mitohe") {
    result = convertSquareMileToHectare(parseFloat(val));
  }
  return result;
}

function getFinalSquareYardConversion(val, conType) {
  let result = "";
  if (conType === "ydtomi") {
    result = convertSquareYardToSquareMile(parseFloat(val));
  } else if (conType === "ydtoac") {
    result = convertSquareYardToAcre(parseFloat(val));
  } else if (conType === "ydtohe") {
    result = convertSquareYardToHectare(parseFloat(val));
  } else if (conType === "ydtoft") {
    result = convertSquareYardToSquareFoot(parseFloat(val));
  } else if (conType === "ydtoin") {
    result = convertSquareYardToSquareInch(parseFloat(val));
  } else if (conType === "ydtom") {
    result = convertSquareYardToSquareMeter(parseFloat(val));
  }

  return result;
}

export {
  getFinalSquareYardConversion,
  getFinalSquareMileConversion,
  getFinalSquareMeterConversion,
  getFinalSquareInchConversion,
  getFinalSquareFootConversion,
  getFinalHectareConversion,
  getFinalAcreConversion
};
